import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {api} from 'api/setup';
import {QueryKeyEnum} from 'types';
import {IGetOrdersRequest, IOrder} from 'types';

const BASE_PATH = 'orders';

export const useOrders = (params: IGetOrdersRequest, options?: UseQueryOptions<IOrder[]>) => {
  return useQuery<IOrder[]>({
    queryKey: [QueryKeyEnum.USER_ORDERS],
    queryFn: async () => {
      return api.get(`/${BASE_PATH}`, {
        params,
      });
    },
    ...options,
  });
};
